import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { handleDob } from "../nspHandlers";
import DobInput from "../DobInput";

export default function StepPersonal({ data, update, onAlert }) {
  const {
    title,
    firstName,
    middleName,
    surname,
    address,
    address2,
    city,
    country,
    postCode,
    homePhone,
    mobilePhone,
    DOB,
    NIN,
  } = data;

  return (
    <Box component="section" className="nsp_step">
      <TextField
        select
        id="title"
        label="Title"
        required
        value={title}
        onChange={(e) => update("title", e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="--Please Select One--">--Please Select One--</MenuItem>
        <MenuItem value="Ms">Ms</MenuItem>
        <MenuItem value="Miss">Miss</MenuItem>
        <MenuItem value="Mr">Mr</MenuItem>
        <MenuItem value="Mx">Mx</MenuItem>
      </TextField>

      <TextField
        id="firstName"
        label="First Name"
        required
        placeholder="Name"
        value={firstName}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("firstName", e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        id="middleName"
        label="Middle Name(s)"
        placeholder="Middle name(s)"
        value={middleName}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("middleName", e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        id="lastName"
        label="Last Name"
        required
        placeholder="Last Name"
        value={surname}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("surname", e.target.value)}
        sx={{ mb: 2 }}
      />

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Home Address <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>*</Box>
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="AddressLine1"
            label="Address Line 1"
            required
            placeholder="Address Line 1"
            value={address}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("address", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="AddressLine2"
            label="Address Line 2"
            placeholder="Address Line 2"
            value={address2}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("address2", e.target.value)}
          />
        </Grid>
      </Grid>

      <TextField
        placeholder="City"
        label="City"
        required
        id="City"
        value={city}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("city", e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        placeholder="Country"
        label="Country"
        id="country"
        value={country}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("country", e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        placeholder="Post Code"
        label="Post Code"
        required
        id="postCode"
        value={postCode}
        inputProps={{ maxLength: 8 }}
        onChange={(e) => update("postCode", e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        inputMode="tel"
        id="homePhone"
        label="Home Phone"
        placeholder="Home Phone"
        value={(homePhone || "").replace(/\D/g, "")}
        inputProps={{ maxLength: 11, inputMode: "tel" }}
        onChange={(e) => update("homePhone", e.target.value.replace(/\D/g, "").slice(0, 11))}
        sx={{ mb: 2 }}
      />

      <TextField
        id="mobilePhone"
        label="Mobile Phone"
        required
        placeholder="Mobile Phone"
        value={(mobilePhone || "").replace(/\D/g, "")}
        inputProps={{ maxLength: 11, inputMode: "tel" }}
        onChange={(e) => update("mobilePhone", e.target.value.replace(/\D/g, "").slice(0, 11))}
        sx={{ mb: 2 }}
      />

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Date of Birth <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>*</Box>
      </Typography>
      <DobInput
        id="dob_input"
        value={DOB}
        onChange={(v) =>
          handleDob(
            v,
            (val) => update("DOB", val),
            onAlert?.setMessage,
            onAlert?.setErrorAlert,
            onAlert?.setSeverity,
            () => update("DOB", "")
          )
        }
      />

      <TextField
        id="NIN"
        label="National Insurance Number"
        required
        placeholder="National Insurance Number"
        inputProps={{ maxLength: 9 }}
        value={NIN}
        onChange={(e) => update("NIN", e.target.value)}
        sx={{ mb: 2 }}
      />
    </Box>
  );
}
